/**
 * The copy of the three announced-and-unbuilt functions, apart from the screen,
 * for the same reason `mediaKitCopy.ts` is: these sentences are the whole of
 * what the product promises about them, and reviewing them next to each other
 * is what keeps a promise from creeping in.
 *
 * **None of them says what the feature will do.** That is not an omission to be
 * fixed later — the screen exists precisely because nobody has decided yet, and
 * a lead that described the thing would answer the question it is there to ask.
 */
export type DevelopmentSurface = 'ideias' | 'memorias' | 'agentes';

export interface DevelopmentCopy {
  title: string;
  lead: string;
  question: string;
  hint: string;
  thanks: string;
}

const NOT_READY = 'Esta função ainda está em construção, então ela não abre por enquanto.';

export const IN_DEVELOPMENT: Record<DevelopmentSurface, DevelopmentCopy> = {
  ideias: {
    title: 'Minhas ideias',
    lead: `${NOT_READY} O que vai existir aqui ainda não está decidido, e é você quem decide melhor do que a gente.`,
    question: 'O que você gostaria de encontrar em "Minhas ideias"?',
    hint: 'Escreva do seu jeito. Um exemplo do que você faria com isso vale mais que uma lista de funções.',
    thanks: 'Anotado. A sua resposta vai junto com as outras quando essa tela for desenhada.'
  },
  memorias: {
    title: 'Minhas memórias',
    lead: `${NOT_READY} O que vai existir aqui ainda não está decidido, e é você quem decide melhor do que a gente.`,
    question: 'O que você gostaria que o Roteirovisk lembrasse de você?',
    hint: 'Escreva do seu jeito. Um exemplo do que você faria com isso vale mais que uma lista de funções.',
    thanks: 'Anotado. A sua resposta vai junto com as outras quando essa tela for desenhada.'
  },
  agentes: {
    title: 'Meus agentes',
    lead: `${NOT_READY} O que vai existir aqui ainda não está decidido, e é você quem decide melhor do que a gente.`,
    question: 'O que você gostaria que um agente fizesse por você?',
    hint: 'Escreva do seu jeito. Um exemplo do que você faria com isso vale mais que uma lista de funções.',
    thanks: 'Anotado. A sua resposta vai junto com as outras quando essa tela for desenhada.'
  }
};
